var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaPdfFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-file-pdf 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 58H14V64H8C3.5875 64 0 60.4125 0 56V8C0 3.5875 3.5875 0 8 0H28.6875C30.8125 0 32.85 0.8375 34.35 2.3375L45.6625 13.65C47.1625 15.15 48 17.1875 48 19.3125V38H42V20H32C29.7875 20 28 18.2125 28 16V6H8C6.9 6 6 6.9 6 8V56C6 57.1 6.9 58 8 58ZM22 44H26C29.8625 44 33 47.1375 33 51C33 54.8625 29.8625 58 26 58H24V62C24 63.1 23.1 64 22 64C20.9 64 20 63.1 20 62V56V46C20 44.9 20.9 44 22 44ZM26 54C27.6625 54 29 52.6625 29 51C29 49.3375 27.6625 48 26 48H24V54H26ZM38 44H42C45.3125 44 48 46.6875 48 50V58C48 61.3125 45.3125 64 42 64H38C36.9 64 36 63.1 36 62V46C36 44.9 36.9 44 38 44ZM42 60C43.1 60 44 59.1 44 58V50C44 48.9 43.1 48 42 48H40V60H42ZM52 46C52 44.9 52.9 44 54 44H60C61.1 44 62 44.9 62 46C62 47.1 61.1 48 60 48H56V52H60C61.1 52 62 52.9 62 54C62 55.1 61.1 56 60 56H56V62C56 63.1 55.1 64 54 64C52.9 64 52 63.1 52 62V54V46Z",
    fill: "#2F4C99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaPdfFile);
export default __webpack_public_path__ + "static/media/fa-pdf-file.ea4213bc0616c676f20e06b19c63038d.svg";
export { ForwardRef as ReactComponent };